import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { InputField } from '@/components/molecules/input-field'
import { ApiCredential, ApiCredentialField } from '@/models/lock-setting'

export type SmartLockApiCredentialProps = {
  fields: ApiCredentialField[]
  value: ApiCredential
  errorFields: ApiCredentialField[]
  onChange: (field: ApiCredentialField, value: string) => void
}

const labelByField: Record<ApiCredentialField, string> = {
  [ApiCredentialField.ApiToken]: 'API token',
  [ApiCredentialField.ApiSecret]: 'API secret',
}

export const SmartLockApiCredentialInput: React.FC<SmartLockApiCredentialProps> = ({ fields, value, errorFields, onChange }) => {
  const { t } = useTranslation()

  return (
    <>
      {fields.map(field => (
        <InputField
          key={field}
          value={value[field] ?? ''}
          placeholder={t(labelByField[field])}
          marginBottom={0}
          width={263}
          fieldWidth="auto"
          error={errorFields.includes(field) ? t('Please enter') : undefined}
          // 認証情報に空白は含まれないため、コピー時に紛れる前後の空白は落として渡す
          handleChangeData={e => onChange(field, e.target.value.trim())}
          customStyle={css({ marginLeft: 16 })}
        />
      ))}
    </>
  )
}
